import { useTenantConfig } from '../hooks/useTenantConfig';
import { usePlatformName } from '../hooks/useWhitelabelOverrides';
import { SidebarTrigger } from '../components/ui/sidebar';
import DashboardDetail from './analysis/DashboardDetail';

export default function Home() {
  const { data: tenantConfig } = useTenantConfig();
  const platformName = usePlatformName();

  if (tenantConfig?.default_dashboard_id) {
    return (
      <div className="flex flex-col h-full">
        <div className="flex-1">
          <DashboardDetail embeddedDashboardId={tenantConfig.default_dashboard_id} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full p-8 relative">
      <div className="md:hidden absolute top-3 left-3">
        <SidebarTrigger className="h-5 w-5" />
      </div>
      <div className="flex flex-col items-center justify-center flex-1">
        <h1 className="text-3xl font-bold text-foreground mb-4 text-center">Welcome to&nbsp;{platformName}</h1>
        <p className="text-muted-foreground text-center max-w-md">
          Your low-code data platform for analytics and AI. Get started by exploring your data or chatting with Ellie.
        </p>
      </div>
    </div>
  );
}
